"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/elements/Icone.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icone = function (_React$Component) {
    _inherits(Icone, _React$Component);

    function Icone() {
        _classCallCheck(this, Icone);

        return _possibleConstructorReturn(this, (Icone.__proto__ || Object.getPrototypeOf(Icone)).apply(this, arguments));
    }

    _createClass(Icone, [{
        key: "getClass",
        value: function getClass() {
            if (this.props.button && !this.props.list) return "btn-icon ";
            return "";
        }
    }, {
        key: "getIcone",
        value: function getIcone() {
            var fontSize = (this.props.tamanho ? this.props.tamanho : 1) + "em" + (this.props.important ? " !important" : '');
            return this.props.fontAwesome ? _react2.default.createElement("i", { "aria-hidden": "true", className: (this.props.fab ? this.props.fab : "fas") + " fa-" + this.props.icone, style: { fontSize: fontSize } }) : _react2.default.createElement(
                "i",
                { className: "material-icons " + this.getClass() + (this.props.className ? this.props.className : ""), "aria-hidden": "true", style: { fontSize: fontSize } },
                this.props.icone
            );
        }
    }, {
        key: "render",
        value: function render() {
            return this.getIcone();
        }
    }]);

    return Icone;
}(_react2.default.Component);

exports.default = Icone;


Icone.propTypes = {
    icone: _propTypes2.default.string.isRequired,
    fab: _propTypes2.default.string,
    fontAwesome: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/elements/Icone.js
// module id = 35
// module chunks = 0